export const VARIANTS = [
  {
    code: 'free',
    values: {
      sizeChartCount: 200,
      advisorCount: '10 000',
      businessApiCount: '50 000',
      productCount: Infinity,
      userCount: Infinity,
      advisorMeasures: true,
      advisorBrands: true,
      advisorSmart: true,
      analytics: false,
      price: { czk: 0, eur: 0 },
    },
  },
  {
    code: 'small',
    values: {
      sizeChartCount: 50,
      advisorCount: '1 000',
      businessApiCount: '10 000',
      productCount: Infinity,
      userCount: Infinity,
      advisorMeasures: true,
      advisorBrands: true,
      advisorSmart: false,
      analytics: false,
      price: { czk: 790, eur: '34,90' },
    },
  },
  {
    code: 'medium',
    values: {
      sizeChartCount: 100,
      advisorCount: '5 000',
      businessApiCount: '30 000',
      productCount: Infinity,
      userCount: Infinity,
      advisorMeasures: true,
      advisorBrands: true,
      advisorSmart: false,
      analytics: false,
      price: { czk: '1 490', eur: '59,90' },
    },
  },
  {
    code: 'large',
    values: {
      sizeChartCount: 200,
      advisorCount: '20 000',
      businessApiCount: '50 000',
      productCount: Infinity,
      userCount: Infinity,
      advisorMeasures: true,
      advisorBrands: true,
      advisorSmart: true,
      analytics: false,
      price: { czk: '2 290', eur: '89,90' },
    },
  },
  {
    code: 'individual',
    values: {
      sizeChartCount: 'tailored',
      advisorCount: 'tailored',
      businessApiCount: 'tailored',
      productCount: Infinity,
      userCount: Infinity,
      advisorMeasures: true,
      advisorBrands: true,
      advisorSmart: true,
      analytics: true,
      price: 'contact',
    },
  },
];

export type VariantsType = typeof VARIANTS;
